import { Button, Heading, Section, Wrapper } from 'components/base';
import PropTypes from 'prop-types';
import React from 'react';
import { signUpUrl } from 'utils/config';

const Banner = ({ data: { heading, subheading, btnText } }) => (
  <Section>
    <Wrapper size="SL" className="text-center">
      <Heading Tag="h1" size="L" marginBottom="Xs" bold>
        {heading}
      </Heading>
      <Heading Tag="h2" size="SM" marginBottom="S">
        {subheading}
      </Heading>
      <Button href={signUpUrl} type="nlGradient" size="L" text={btnText} />
    </Wrapper>
  </Section>
);
Banner.propTypes = {
  data: PropTypes.object,
};

export default Banner;
